import { deleteField, doc, getDoc, setDoc } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';

const lyricsRef = (db: Firestore, uid: string) => doc(db, 'users', uid, 'data', 'lyrics');

export async function loadCustomLyrics(db: Firestore, uid: string, videoId: string): Promise<string> {
  const snapshot = await getDoc(lyricsRef(db, uid));
  if (!snapshot.exists()) return '';
  const value = snapshot.data()?.items?.[videoId];
  return typeof value === 'string' ? value : '';
}

export async function saveCustomLyrics(db: Firestore, uid: string, videoId: string, value: string): Promise<void> {
  await setDoc(lyricsRef(db, uid), { items: { [videoId]: value } }, { merge: true });
}

export async function deleteCustomLyrics(db: Firestore, uid: string, videoId: string): Promise<void> {
  await setDoc(lyricsRef(db, uid), { items: { [videoId]: deleteField() } }, { merge: true });
}
